import React from "react";
import { motion } from "framer-motion";
import pizzaioliImg from "../../assets/team/pizzaioli.png";

export default function PizzaioliSection() {
    return (
        <section 
            id="filosofia" 
            className="relative bg-[#090D16] px-6 py-24 md:py-32 overflow-hidden border-b border-accent/10"
        >
            {/* Elemento di luce d'atmosfera sullo sfondo */}
            <div className="absolute top-1/2 left-1/4 -translate-y-1/2 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" />

            <div className="relative max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-12 lg:gap-16 z-10">
                
                {/* Colonna Testo */}
                <div className="w-full lg:w-1/2 text-left space-y-6">
                    <div className="space-y-2">
                        <motion.span 
                            className="text-primary text-xs font-black tracking-widest uppercase block"
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5 }}
                        >
                            Dietro le Quinte
                        </motion.span>
                        
                        <motion.h2
                            className="text-3xl md:text-4xl font-title text-secondary tracking-tight leading-tight"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6 }}
                        >
                            La nostra filosofia
                        </motion.h2>
                    </div>

                    {/* Sottile divisore di design */}
                    <motion.div 
                        className="w-12 h-[2px] bg-primary/60 rounded-full"
                        initial={{ width: 0 }}
                        whileInView={{ width: 48 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    />

                    <div className="space-y-4 text-muted text-sm md:text-base leading-relaxed">
                        <motion.p
                            initial={{ opacity: 0, y: 15 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.2, duration: 0.6 }}
                        >
                            Noi de <span className="text-secondary font-medium">Il Balconcino Food&Beer</span> crediamo che mangiare non sia solo un'azione ordinaria, ma un vero momento rituale per appagare il corpo e la mente. 
                        </motion.p>
                        
                        <motion.p
                            initial={{ opacity: 0, y: 15 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.3, duration: 0.6 }}
                        >
                            In ogni nostra creazione riversiamo la passione intransigente che ci contraddistingue, selezionando rigorosamente materie prime d'eccellenza e adottando lavorazioni scrupolose a ciclo lento.
                        </motion.p>

                        <motion.p
                            className="pt-2 border-l-2 border-primary/30 pl-4 italic text-secondary/90"
                            initial={{ opacity: 0, x: -10 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: 0.4, duration: 0.6 }}
                        >
                            <strong className="text-primary not-italic font-bold">Gianmarco</strong> e <strong className="text-primary not-italic font-bold">Raffaele</strong> sono il cuore pulsante del nostro laboratorio: esperienza, tecnica artigianale e intuito creativo dietro ogni singola pala. Un duo affiatato che trasforma acqua e farina in pura autenticità.
                        </motion.p>
                    </div>
                </div>

                {/* Colonna Immagine con Frame Architetturale */}
                <motion.div 
                    className="w-full lg:w-1/2 relative group"
                    initial={{ opacity: 0, scale: 0.98, y: 30 }}
                    whileInView={{ opacity: 1, scale: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                >
                    
                    {/* Contenitore Immagine Effettivo */}
                    <div className="relative overflow-hidden rounded-lg bg-surface aspect-[4/3] sm:aspect-video lg:aspect-[4/3]">
                        <img
                            src={pizzaioliImg}
                            alt="Gianmarco e Raffaele - I maestri pizzaioli de Il Balconcino"
                            className="w-full h-full object-cover brightness-[1.02] contrast-[1.02] transition-transform duration-700 ease-out group-hover:scale-105"
                            draggable={false}
                            loading="lazy"
                        />
                        {/* Soft overlay scuro che scompare al passaggio del mouse */}
                        <div className="absolute inset-0 bg-black/15 group-hover:opacity-0 transition-opacity duration-500 pointer-events-none" />
                    </div>

                    {/* Micro-dettaglio decorativo geometrico (angolo) */}
                    <div className="absolute -bottom-2 -right-2 w-16 h-16 border-b-2 border-r-2 border-primary/40 rounded-br-2xl pointer-events-none group-hover:w-20 group-hover:h-20 transition-all duration-500" />
                </motion.div>

            </div>
        </section>
    );
}